import { setLocale } from 'yup';
import { isNullOrUndefined } from '@shared/utils';

setLocale({
	// use functions to generate an error object that includes the value from the schema
	string: {
		min: ({ min }) => ({ value: 'min', action: 't', params: { field: { value: 'password', action: 't' }, min: { value: min } } }),
		max: ({ max }) => ({ value: 'max', action: 't', params: { field: { value: 'password', action: 't' }, max: { value: max } } }),
	},
});

// pluralize
const p = function (word, num) {
	return num === 1 ? word : `${word}s`
}

function minLowercase(length = 1, message) {
	return this.test({
		name: 'minLowercase',
		exclusive: true,
		message: {
			value: 'mustContainAtleastLowercase',
			action: 't',
			params: { length: { value: length } },
		},
		params: { length },
		test(value) {
			return isNullOrUndefined(value) || (value.match(/[a-z]/g) || []).length >= length
		},
	})
} // minLowercase()

function minUppercase(length = 1, message) {
	return this.test({
		name: 'minUppercase',
		exclusive: true,
		message: {
			value: 'mustContainAtleastUppercase',
			action: 't',
			params: { length: { value: length } },
		},
		params: { length },
		test(value) {
			return isNullOrUndefined(value) || (value.match(/[A-Z]/g) || []).length >= length
		},
	})
} // minUppercase()

function minNumbers(length = 1, message) {
	return this.test({
		name: 'minNumber',
		exclusive: true,
		message: {
			value: 'mustContainAtleastMinNumbers',
			action: 't',
			params: { length: { value: length } },
		},
		params: { length },
		test(value) {
			return isNullOrUndefined(value) || (value.match(/[0-9]/g) || []).length >= length
		},
	})
} // minNumber()

function minSymbols(length = 1, message) {
	return this.test({
		name: 'minSymbol',
		exclusive: true,
		message: {
			value: 'mustContainAtleastMinSymbols',
			action: 't',
			params: { length: { value: length } },
		},
		params: { length },
		test(value) {
			return isNullOrUndefined(value) || (value.match(/[^a-zA-Z0-9\s]/g) || []).length >= length
		},
	})
} // minSymbol()


// function checkEnglish(length = 1, message) {
//     return this.test({
//         name: 'checkEnglish',
//         exclusive: true,
//         message: {
//             value: 'mustEnglishCharcter',
//             action: 't',
//         },
//         test(value) {
//             return isNullOrUndefined(value) || value.match(/^[A-Za-z]/g)
//         }
//     })
// } // checkEnglish()

function minRepeating(length = 2, message) {
	return this.test({
		name: 'minRepeating',
		exclusive: true,
		message: {
			value: 'mustContainAtleastMinRepeating',
			action: 't',
			params: { length: { value: length } },
		},
		params: { length },
		test(value) {
			return isNullOrUndefined(value) || ! new RegExp(`(.)\\1{${length},}`).test(value)
		},
	})
} // minRepeating()

function minWords(length = 2, message) {
	// const msg = message || '${path} must contain at least ${length} ' + p('word', length)
	const rx = new RegExp('[a-zA-Z0-9]')
	return this.test({
		name: 'minWords',
		exclusive: true,
		message: {
			value: 'mustContainAtleastMinWords',
			action: 't',
			params: { length: { value: length } },
		},        
		params: { length },
		test(value) {
			return isNullOrUndefined(value) || value.split(' ').filter(v => !! v && rx.test(v)).length >= length
		},
	})
} // minWords()

function password() {
	return this
	// .checkEnglish()
		.min(8)
		.max(250)
		.minLowercase(1)
		.minUppercase(1)
		.minNumbers(1)
		.minSymbols(1)
} // password()

function setup(yup) {
	yup.addMethod(yup.string, 'minLowercase', minLowercase)
	yup.addMethod(yup.string, 'minUppercase', minUppercase)
	yup.addMethod(yup.string, 'minNumber', minNumbers)
	yup.addMethod(yup.string, 'minNumbers', minNumbers)
	yup.addMethod(yup.string, 'minSymbol', minSymbols)
	yup.addMethod(yup.string, 'minSymbols', minSymbols)
	yup.addMethod(yup.string, 'minRepeating', minRepeating)
	yup.addMethod(yup.string, 'minWords', minWords)
	// yup.addMethod(yup.string, 'checkEnglish', checkEnglish)
	yup.addMethod(yup.string, 'password', password)
}

// module.exports = setup

export default setup;
